import Logo from "src/assets/brands/loader.svg";
const Loader = () => {
  return (
    <div className="loading-container">
      <div className="spinner-container" >
        <div className="spinner-circle" />
        <div className="spinner-content">
            <img src={Logo} width="40px" />
        </div>
      </div>
    </div>
  )
}

export default Loader;
